interface ProgressRingProps {
  /** 0..100 */
  value: number;
  size?: number;
  stroke?: number;
  color?: string;
  label?: string;
}

/** The circular percentage used on Home and Progress. Pure SVG, no library. */
export function ProgressRing({
  value,
  size = 140,
  stroke = 10,
  color = 'var(--accent)',
  label,
}: ProgressRingProps) {
  const clamped = Math.max(0, Math.min(100, value));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (clamped / 100) * circumference;

  return (
    <div className="ring" style={{ width: size, height: size, position: 'relative' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label ?? `${clamped}%`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--surface-sunk)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference - dash}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'grid',
          placeItems: 'center',
          fontWeight: 800,
          fontSize: size * 0.24,
          letterSpacing: '-0.02em',
        }}
        className="tnum"
        aria-hidden="true"
      >
        <span>
          {Math.round(clamped)}
          <span style={{ fontSize: '0.55em', color: 'var(--ink-muted)' }}>%</span>
        </span>
      </div>
    </div>
  );
}
